import { type RouteObject } from "react-router-dom";

import { AUTH_ROLES } from "api/common/types/auth.types";
import PCMDetails from "components/NIAPAdmin/PCM/PCMDetails";
import PCMTable from "components/NIAPAdmin/PCM/PCMTable";
import PcmUpdateModal from "features/memberPortal/products/productDetails/ProductUpdates/modals/PcmUpdate.modal";
import PcmUpdates from "features/memberPortal/products/productDetails/ProductUpdates/PcmUpdates.screen";
import AuthenticatedRoute from "routing/AuthenticatedRoute";

const { NIAP } = AUTH_ROLES;

const pcmRoutes: RouteObject[] = [
  {
    path: "pcm",
    element: <AuthenticatedRoute allowedRoles={[NIAP]} />,

    children: [
      {
        index: true,
        element: <PCMTable />,
      },
      {
        path: "details/:id",
        children: [
          {
            index: true,
            element: <PCMDetails />,
          },
          {
            path: "updates",
            element: <AuthenticatedRoute allowedRoles={[NIAP]} />,
            children: [
              {
                path: "",
                element: <PcmUpdates />,
                children: [
                  {
                    path: "add",
                    element: <PcmUpdateModal />,
                  },
                  {
                    path: ":updateId/edit",
                    element: <PcmUpdateModal editMode />,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

export default pcmRoutes;
